module.exports = __webpack_public_path__ + "img/gender.5fe2a460.svg";